import { useRouter } from '@/app/composable/router';
import { UserRoles } from '@/app/constants';
import store from '@/app/store';
import { NavigationGuard, Route } from 'vue-router';

type Next = Parameters<NavigationGuard>[2];

export const RoleGuard = async (to: Route, from: Route, next: Next, roles: UserRoles[]) => {
    const { user } = store.state.auth;

    if (user && user.roles && user.roles.length > 0 && roles.some((role: string) => user.roles.includes(role))) {
        return next();
    }

    const root = useRouter();

    (root.app as any).$toastr.e('You do not have access to view this page.', 'Error');

    return next({ name: 'home' });
};
